import { MainContainer } from "../../components/Contents/Contents.element";
import { useLoading } from "../../contexts/LoadingContext";
import PageHeader from "../../layout/PageHeader";
import LoadingSpinner from "../../ui/LoadingSpinner";
import PlayerSearchInit from "../../components/PlayerLanding/PlayerSearch/PlayerSearchInit";
import { usePlayerSearch } from "../../contexts/SearchPlayersContext";
import { useNotification } from "../../contexts/NotificationContext";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";

const PlayerSearchInitiate = () => {
  const { loading } = useLoading();
  const {
    setPlayerSearchResultsVisible, handleSelectedPlayer,
    handleSelectedAttributes, setAllProfiles, handleSelectedProfiles, handleSelectedPlayerZones,
    setTransferValue,setTrueValue,trueValue, transferValue, contractUntilValue, setContractUntilValue, setAgeRange, ageRange,
    setMinAppearances, setStartsOnly, setFoot, setRegionValues, setCompetitionValues, handleSelectedTags,
    setIsPlayerFilterChange, setIsAltered, setSimilarPlayerResultsList, handleSelectedPlayerAttributes,
    setPlayerInitialAttributes, setIsExactMatchesOnly, similarPlayerResultsList, originPage, reset,
    setWagesValue , resetAllFilters ,setIsSearchByAttributes
  } = usePlayerSearch();
  const location = useLocation();
  const { hideNotification, setNotificationContent, setDisplayNotification } = useNotification();
  const { isBlurred } = useSidebar();
  const isFromMenu = location.state?.fromMenu;
  const [key, setKey] = useState(0); // State variable to force re-render
  
  const handleClearAllFields = useCallback(() => {
    setPlayerSearchResultsVisible(false);
    handleSelectedPlayer([]);
    setAllProfiles([]);
    handleSelectedPlayerZones([]);
    handleSelectedProfiles([]);
    handleSelectedAttributes([]);
    handleSelectedPlayerAttributes([]);
    setTransferValue({ min: 0, max: 250000000 });
    setTrueValue({ min: 0, max: 250000000 });
    setWagesValue({ min: 0, max: 180000000 });
    setContractUntilValue({ min: 0, max: 120 });
    setAgeRange({ min: 16, max: 50 });
    setMinAppearances(0);
    setStartsOnly(false);
    setFoot([]);
    setRegionValues([]);
    setCompetitionValues([]);
    handleSelectedTags([]);
    setIsPlayerFilterChange(false);
    setIsAltered(false);
    setSimilarPlayerResultsList(undefined);
    setPlayerInitialAttributes([]);
    setIsExactMatchesOnly(false);
    hideNotification();
    setNotificationContent(null);
    setDisplayNotification(false);
    resetAllFilters()
    setIsSearchByAttributes(false)
    setKey(prevKey => prevKey + 1); // Update key to re-render PlayerSearchInit
  }, [
    setPlayerSearchResultsVisible,
    handleSelectedPlayer,
    setAllProfiles,
    handleSelectedPlayerZones,
    handleSelectedProfiles,
    handleSelectedAttributes,
    setTransferValue,
    transferValue,
    setTrueValue,
    trueValue,
    setContractUntilValue,
    contractUntilValue,
    setAgeRange,
    ageRange,
    setMinAppearances,
    setStartsOnly,
    setFoot,
    setRegionValues,
    setCompetitionValues,
    handleSelectedTags,
    setIsPlayerFilterChange,
    setIsAltered,
    setSimilarPlayerResultsList,
    setPlayerInitialAttributes,
    setIsExactMatchesOnly,
    hideNotification,
    setNotificationContent,
    setDisplayNotification,
    setIsSearchByAttributes
  ]);

  useEffect(() => {
    if (isFromMenu) {
      handleSelectedPlayer([]);
      handleSelectedPlayerAttributes([]);
      reset();
      hideNotification();
      setNotificationContent(null);
      setDisplayNotification(false);
      setKey(prevKey => prevKey + 1);
    }
  }, [isFromMenu]);


  return (
    <MainContainer isBlurred={isBlurred!} className="main-container player-detail-page">
      <PageHeader
        title='Players'
        clearAllFields={true}
        onClearAllFields={() => {
          handleClearAllFields();
        }} playerResultList
      />
      {/* Use the key to force re-render PlayerSearchInit */}
      <PlayerSearchInit key={key} />
      {loading && <LoadingSpinner />}
    </MainContainer>
  );
};

export default PlayerSearchInitiate;
